/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ListTradingChallengesOptions,
  ListTradingChallengesStatus200,
  ListTradingChallengesStatus400,
  ListTradingChallengesStatus500,
} from '../types/ListTradingChallenges'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listTradingChallenges } from '../clients/listTradingChallenges'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listTradingChallengesQueryKey = ({
  query,
}: Omit<ListTradingChallengesOptions, 'headers'> = {}) =>
  [{ url: '/v1/trading_challenges' }, ...(query ? [query] : [])] as const

type ListTradingChallengesQueryKey = ReturnType<typeof listTradingChallengesQueryKey>

export function listTradingChallengesQueryOptions(
  { query }: ListTradingChallengesOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = listTradingChallengesQueryKey({ query })
  return queryOptions<
    ListTradingChallengesStatus200,
    ResponseErrorConfig<ListTradingChallengesStatus400 | ListTradingChallengesStatus500>,
    ListTradingChallengesStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listTradingChallenges({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description List trading challenges. COMPETITION_MANAGER callers only receive challenges present in their managed_competition_ids.
 * @summary List trading challenges
 * {@link /v1/trading_challenges}
 */
export function useListTradingChallenges<
  TData = ListTradingChallengesStatus200,
  TQueryData = ListTradingChallengesStatus200,
  TQueryKey extends QueryKey = ListTradingChallengesQueryKey,
>(
  {
    query,
  }: {
    query?: ListTradingChallengesOptions['query'] | (() => ListTradingChallengesOptions['query'])
  } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListTradingChallengesStatus200,
        ResponseErrorConfig<ListTradingChallengesStatus400 | ListTradingChallengesStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? listTradingChallengesQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...listTradingChallengesQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<ListTradingChallengesStatus400 | ListTradingChallengesStatus500>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
